export const iconFontAwesomeFilesNoteSticky = (
	<i className="fa-solid fa-note-sticky"></i>
);
